import React, { useState } from "react";
import Money from "../../../components/Money";
import Button from "../../../components/Button";
import FundCommentaryInfoModal from "./FundCommentaryInfoModal";

const FundCommentaryLoadingPlaceholder = () => {
    return (
        <div
            className={`border bg-white rounded border-slate-300 my-4 p-4 shadow-inner`}
        >
            <div class="animate-pulse flex space-x-4">
                <div class="flex-1 space-y-6 py-1">
                    <div class="space-y-3">
                        <div class="grid grid-cols-3 gap-4">
                            <div class="h-2 bg-slate-400 rounded col-span-2"></div>
                            <div class="h-2 bg-slate-400 rounded col-span-1"></div>
                        </div>
                        <div class="h-2 bg-slate-400 rounded"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FundCommentaryLoadingPlaceholder;
